(function () {
  "use strict";

  if (window.__CUSTOM_COLLECTION_BOUND__) return;
  window.__CUSTOM_COLLECTION_BOUND__ = true;

  /* =========================
     Tiny helpers
  ========================== */
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $all = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const stop = (e) => { if (!e) return; e.preventDefault?.(); e.stopImmediatePropagation?.(); e.stopPropagation?.(); };
  const capFirstStrict = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);

  const toHandle = (s) => {
  if (!s) return '';
  let out = deUmlaut(String(s)).trim().toLowerCase();
  out = out.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); // strip any leftovers
  out = out.replace(/&/g, 'and');
  out = out.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return out;
};
  const toHandleLoose = (s)=>{ try{
    return String(s||'').trim().toLowerCase()
      .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
      .replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'');
  } catch { return ''; } };

 const ORIGINAL_LABELS = new Map();

function harvestOriginalLabels(root) {
  const R = root || document;
  const tidy = (s)=>String(s||'').replace(/\s+/g,' ').trim();

  // A) Theme-specific: sidebar labels carry the human text AND the handle
  R.querySelectorAll('.tag-filter__label[data-checkbox-filter]').forEach(el => {
    const handle = toHandleLoose(el.getAttribute('data-checkbox-filter') || '');
    if (!handle) return;
    const txt = tidy(el.getAttribute('title') || el.textContent || '');
    if (txt) ORIGINAL_LABELS.set(handle, txt);
  });

  // B) Standard: pair inputs with their <label for="..."> text
  R.querySelectorAll('[data-tag-filter-checkbox]').forEach(cb => {
    const raw = cb.getAttribute('data-filter-value') || cb.value || '';
    const h = toHandleLoose(raw);
    if (!h) return;

    let txt = '';
    // try <label for="id">
    const id = cb.getAttribute('id');
    if (id) {
      const labFor = R.querySelector(`label[for="${CSS.escape(id)}"]`);
      if (labFor) txt = tidy(labFor.getAttribute('title') || labFor.textContent || '');
    }
    // try closest label (some themes wrap the input)
    if (!txt) {
      const lab = cb.closest('label');
      if (lab) {
        const inner = lab.querySelector('.tag-filter__label');
        txt = tidy(
          (inner && (inner.getAttribute('title') || inner.textContent)) ||
          lab.getAttribute('title') ||
          lab.textContent || ''
        );
      }
    }
    if (txt) ORIGINAL_LABELS.set(h, txt);
  });

  // C) Learn from any visible pills / chips (mobile/top rows)
  R.querySelectorAll('.pill-filter,[data-pill-tag]').forEach(el => {
    const raw = el.getAttribute('data-filter-value') || el.getAttribute('data-pill-tag') || '';
    const h = toHandleLoose(raw);
    if (!h) return;
    let txt = tidy(
      el.querySelector('.active-value-pill__text')?.textContent ||
      el.getAttribute('title') ||
      el.textContent || ''
    ).replace(/[×✕✖︎]+/g,'').trim();
    if (txt) ORIGINAL_LABELS.set(h, txt);
  });
}

function labelFor(handle, fallback){
  const h = toHandleLoose(handle || '');
  return (h && ORIGINAL_LABELS.get(h)) || (fallback ?? handle ?? '');
}


function labelFor(handle, fallback){
  const h = toHandleLoose(handle || '');
  return (h && ORIGINAL_LABELS.get(h)) || (fallback ?? handle ?? '');
}


  /* =========================
     Env
  ========================== */
  const RAW_SECTION_ID =
    (window.__FILTERS__ && window.__FILTERS__.SECTION_ID) ||
    (window.__COLL_ENV__ && window.__COLL_ENV__.SECTION_DOM_ID) ||
    (window.__SECTION_DOM_ID__ || "").replace("shopify-section-", "") ||
    "";

  const COLLECTION_PATH = (
    document.documentElement.getAttribute("data-collection-url") ||
    (window.__FILTERS__ && window.__FILTERS__.COLLECTION_PATH) ||
    (location.pathname.match(/^\/collections\/[^\/?#]+/) || [""])[0] ||
    "/"
  ).replace(/\/$/, "");

  const NO_PRODUCTS_TEXT =
    (window.__COLL_ENV__ && window.__COLL_ENV__.NO_PRODUCTS_TEXT) ||
    (window.translations && window.translations.collections_no_matches) ||
    "Keine Produkte in dieser Kollektion gefunden";

  const IS_LOCALHOST = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);

  /* boot & seq */
  let __BOOT_DONE__ = false;
  let applySeq = 0;

  /* selection-change tracker (for page reset) */
  let __LAST_SELECTION_KEY__ = null;
  function makeSelectionKey(groups) {
    try {
      const names = Object.keys(groups || {}).sort();
      return names.map(n => {
        const vals = (groups[n] || [])
          .slice()
          .map(String)
          .map(s => s.toLowerCase())
          .sort();
        return `${n}:${vals.join(',')}`;
      }).join('|');
    } catch { return ''; }
  }

  /* mobile/group-panel UI state */
  let groupPanel;
  let groupPanelBackdrop;
  let CURRENT_OPEN_GROUP = null;
  let __IS_INITIAL_HYDRATE__ = true;  // keep current URL (page/sort/badge) on first load

  /* icons */
  const ICONS = { CLOSE: null, CARET: null };

  function cacheIconsFromDOM() {
    try {
      const closeSvg = document.querySelector(".filter-close svg");
      if (closeSvg) ICONS.CLOSE = closeSvg.outerHTML;
    } catch {}
    try {
      const caretSvg =
        document.querySelector(".sidebar-block__toggle-icon .icon--active svg") ||
        document.querySelector(".sidebar-block__toggle-icon svg");
      if (caretSvg) ICONS.CARET = caretSvg.outerHTML;
    } catch {}
    if (!ICONS.CLOSE) ICONS.CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.7a1 1 0 0 0-1.4-1.4L12 9.17 7.1 4.3A1 1 0 0 0 5.7 5.7L10.59 10.6 5.7 15.49a1 1 0 1 0 1.41 1.41L12 12.01l4.89 4.89a1 1 0 1 0 1.41-1.41L13.41 10.6 18.3 5.7Z"/></svg>';
    if (!ICONS.CARET) ICONS.CARET = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.7 9.3a1 1 0 0 1 1.4 0L12 13.17l3.9-3.87a1 1 0 1 1 1.4 1.43l-4.6 4.57a1.5 1.5 0 0 1-2.12 0L6.7 10.73a1 1 0 0 1 0-1.43Z"/></svg>';
  }

  /* =========================
     Pending flash guard
  ========================== */
  const __PENDING_STYLE__ = document.createElement('style');
  __PENDING_STYLE__.id = 'coll-pending-style';
  __PENDING_STYLE__.textContent = `
    [data-coll-pending] .container--no-products-in-collection{display:none!important;}
  `;
  document.head.appendChild(__PENDING_STYLE__);

  /* =========================
     Per-page detection
  ========================== */
  let PER_PAGE = null;

  function readPerPageFromSectionJSON(root) {
    try {
        const dataEl = (root || document).querySelector('script[data-section-data]');
        if (!dataEl?.textContent) return null;
        const parsed = JSON.parse(dataEl.textContent);
        const keys = ['products_per_page', 'per_page', 'items_per_page', 'collection_products_per_page'];
        for (const k of keys) {
          const v = parsed?.[k];
          if (typeof v === 'number' && v > 0) return v;
        }
        return null;
    } catch { return null; }
  }

  async function fetchBasePerPage() {
    try {
      const { section } = buildSeoURLFromHandles([], { page: 1 });
      const bits = await fetchBits(section);
      const fromJSON = readPerPageFromSectionJSON(bits.rootFrag);
      if (typeof fromJSON === 'number' && fromJSON > 0) return fromJSON;

      const grid = bits?.grid;
      if (!grid) return null;
      const cnt = grid.children ? grid.children.length : 0;
      return (cnt > 0) ? cnt : null;
    } catch { return null; }
  }

  function detectPerPageFromDOMLoose() {
    try {
      const grid = $('[data-collection-main] .collection-matrix') || $('.collection-matrix');
      if (!grid) return null;
      const cnt = grid.children ? grid.children.length : 0;
      return cnt > 0 ? cnt : null;
    } catch { return null; }
  }

  async function ensurePerPage() {
    if (PER_PAGE != null && !isNaN(PER_PAGE)) return PER_PAGE;

    const fromJSON = readPerPageFromSectionJSON(document);
    if (typeof fromJSON === 'number' && fromJSON > 0) {
      PER_PAGE = fromJSON; return PER_PAGE;
    }

    try {
      const cached = sessionStorage.getItem('__COLL_PER_PAGE');
      if (cached) {
        const v = Number(cached);
        if (isFinite(v) && v > 0) { PER_PAGE = v; return PER_PAGE; }
      }
    } catch {}

    const base = await fetchBasePerPage();
    if (typeof base === 'number' && base > 0) {
      PER_PAGE = base;
      try { sessionStorage.setItem('__COLL_PER_PAGE', String(PER_PAGE)); } catch {}
      return PER_PAGE;
    }

    const loose = detectPerPageFromDOMLoose();
    PER_PAGE = (typeof loose === 'number' && loose > 0) ? loose : 24;
    try { sessionStorage.setItem('__COLL_PER_PAGE', String(PER_PAGE)); } catch {}
    return PER_PAGE;
  }

  /* =========================
     URL params (page / badge)
  ========================== */
  function getPageFromURL(){
    try {
      const p = Number(new URLSearchParams(location.search).get('page') || '1');
      return (isFinite(p) && p > 0) ? p : 1;
    } catch { return 1; }
  }
  function getBadgesFromURL(){
    try {
      const raw = (new URL(location.href)).searchParams.get('badge') || '';
      return raw.split(',').map(toHandleLoose).filter(Boolean);
    } catch { return []; }
  }
  function setBadgesInURL(u, badges){
    const list = Array.from(new Set((badges||[]).map(toHandleLoose).filter(Boolean)));
    if (list.length) u.searchParams.set('badge', list.join(','));
    else u.searchParams.delete('badge');
  }

  /* =========================
     Pager template capture
  ========================== */
  let PAGER_TEMPLATE_EL = null;

  function cachePagerFrom(bitsOrEl) {
    if (PAGER_TEMPLATE_EL) return;
    const el =
      bitsOrEl?.querySelector?.('.paginate') ||
      (bitsOrEl?.pager && bitsOrEl.pager.querySelector?.('.paginate')) ||
      document.querySelector('.paginate') ||
      null;
    if (el && el.classList?.contains('paginate')) {
      PAGER_TEMPLATE_EL = el.cloneNode(true);
    }
  }

  async function ensurePagerTemplate() {
    if (PAGER_TEMPLATE_EL) return;
    try {
      cachePagerFrom(document);
      if (PAGER_TEMPLATE_EL) return;
      const { section } = buildSeoURLFromHandles([], { page: 2 });
      const bits = await fetchBits(section);
      const fetchedPaginate = bits.rootFrag?.querySelector?.('.paginate');
      if (fetchedPaginate) cachePagerFrom(fetchedPaginate);
    } catch {}
  }

  function buildThemePagerWindow(currentPage, totalPages) {
    if (totalPages <= 1) return null; // never render pager when only one page
    if (!PAGER_TEMPLATE_EL) return __buildMinimalPagerGeneric(currentPage, totalPages);

    const wrap = PAGER_TEMPLATE_EL.cloneNode(true);
    wrap.setAttribute('data-current-page', String(currentPage));
    wrap.setAttribute('data-paginate-pages', String(totalPages));
    wrap.innerHTML = "";

    const nav = document.createElement('nav');
    nav.className = 'pagination' + ((currentPage > 1 && currentPage < totalPages) ? ' paginate--both' : '');
    nav.setAttribute('role','navigation');
    nav.setAttribute('aria-label','pagination');

    const mkURL = (pageNum) => {
      const { pretty } = buildSeoURLFromHandles(selectedHandlesForURL(), { page: Number(pageNum) });
      const u = new URL(pretty.href);
      if (Number(pageNum) <= 1) u.searchParams.delete('page');
      setBadgesInURL(u, getBadgesFromURL());
      const sort = (new URL(location.href)).searchParams.get('sort_by'); if (sort) u.searchParams.set('sort_by', sort);
      return u.pathname + u.search;
    };

    if (currentPage > 1) {
      const aPrev = document.createElement('a');
      aPrev.className = 'pagination-previous';
      aPrev.textContent = (window.translations?.['general.pagination.previous']) || 'Vorheriger';
      aPrev.href = mkURL(currentPage - 1);
      nav.appendChild(aPrev);
    }

    const ul = document.createElement('ul');
    ul.className = 'pagination-list';

    const addLink = (n, isCurrent = false) => {
      const li = document.createElement('li');
      const a  = document.createElement('a');
      a.className = 'pagination-link' + (isCurrent ? ' is-current' : '');
      a.textContent = String(n);
      if (!isCurrent) a.href = mkURL(n);
      else a.setAttribute('aria-current','page');
      li.appendChild(a);
      ul.appendChild(li);
    };
    const addDots = () => {
      const li = document.createElement('li');
      const a  = document.createElement('a');
      a.className = 'pagination-ellipsis';
      a.innerHTML = '&hellip;';
      li.appendChild(a);
      ul.appendChild(li);
    };

    const last = Math.max(1, Number(totalPages) || 1);

    if (last <= 7) {
      for (let n = 1; n <= last; n++) addLink(n, n === currentPage);
    } else {
      addLink(1, currentPage === 1);
      addLink(2, currentPage === 2);

      const winStart = Math.max(3, currentPage - 1);
      const winEnd   = Math.min(last - 2, currentPage + 1);

      if (winStart > 3) addDots();
      for (let n = winStart; n <= winEnd; n++) addLink(n, n === currentPage);
      if (winEnd < last - 2) addDots();

      addLink(last - 1, currentPage === last - 1);
      addLink(last,     currentPage === last);
    }

    nav.appendChild(ul);

    if (currentPage < last) {
      const aNext = document.createElement('a');
      aNext.className = 'pagination-next';
      aNext.textContent = (window.translations?.['general.pagination.next']) || 'Nächster';
      aNext.href = mkURL(currentPage + 1);
      nav.appendChild(aNext);
    }

    wrap.appendChild(nav);
    return wrap;
  }

  function wakeHorizontalPillsScroll() {
  try {
    const rails = [
      document.querySelector('.filters-pill-row-top'),
      document.querySelector('.filters-pill-row-bottom .active-values-wrap')
    ].filter(Boolean);

    rails.forEach(rail => {
      // make sure the rail itself is a horizontal scroller
      rail.style.overflowX = 'auto';
      rail.style.webkitOverflowScrolling = 'touch';
      rail.style.whiteSpace = 'nowrap';

      // make sure its *first* child can actually overflow
      const inner = rail.firstElementChild;
      if (inner) {
        inner.style.display = 'inline-flex';
        inner.style.minWidth = 'max-content';
        inner.style.whiteSpace = 'nowrap';
      }

      // NUDGE: wake up the compositor (fix for iOS/Chrome mobile)
      const x = rail.scrollLeft || 0;
      rail.scrollLeft = x + 1;
      rail.scrollLeft = x;
    });
  } catch {}
}


  function __buildMinimalPagerGeneric(currentPage, totalPages) {
    if (totalPages <= 1) return null;
    const wrap = document.createElement('div');
    wrap.className = 'paginate';
    wrap.setAttribute('data-current-page', String(currentPage));
    wrap.setAttribute('data-paginate-pages', String(totalPages));

    const nav = document.createElement('nav');
    nav.className = 'pagination' + ((currentPage > 1 && currentPage < totalPages) ? ' paginate--both' : '');
    nav.setAttribute('role','navigation');
    nav.setAttribute('aria-label','pagination');

    const mkURL = (pageNum) => {
      const { pretty } = buildSeoURLFromHandles(selectedHandlesForURL(), { page: Number(pageNum) });
      const u = new URL(pretty.href);
      if (Number(pageNum) <= 1) u.searchParams.delete('page');
      setBadgesInURL(u, getBadgesFromURL());
      const sort = (new URL(location.href)).searchParams.get('sort_by'); if (sort) u.searchParams.set('sort_by', sort);
      return u.pathname + u.search;
    };

    if (currentPage > 1) {
      const aPrev = document.createElement('a');
      aPrev.className = 'pagination-previous';
      aPrev.textContent = (window.translations?.['general.pagination.previous']) || 'Vorheriger';
      aPrev.href = mkURL(currentPage - 1);
      nav.appendChild(aPrev);
    }

    const ul = document.createElement('ul');
    ul.className = 'pagination-list';

    const addLink = (n, isCurrent = false) => {
      const li = document.createElement('li');
      const a  = document.createElement('a');
      a.className = 'pagination-link' + (isCurrent ? ' is-current' : '');
      a.textContent = String(n);
      if (!isCurrent) a.href = mkURL(n);
      else a.setAttribute('aria-current','page');
      li.appendChild(a);
      ul.appendChild(li);
    };

    const addDots = () => {
      const li = document.createElement('li');
      const a  = document.createElement('a');
      a.className = 'pagination-ellipsis';
      a.innerHTML = '&hellip;';
      li.appendChild(a);
      ul.appendChild(li);
    };

    const last = Math.max(1, Number(totalPages) || 1);

    if (last <= 7) {
      for (let n = 1; n <= last; n++) addLink(n, n === currentPage);
    } else {
      addLink(1, currentPage === 1);
      addLink(2, currentPage === 2);

      const winStart = Math.max(3, currentPage - 1);
      const winEnd   = Math.min(last - 2, currentPage + 1);

      if (winStart > 3) addDots();
      for (let n = winStart; n <= winEnd; n++) addLink(n, n === currentPage);
      if (winEnd < last - 2) addDots();

      addLink(last - 1, currentPage === last - 1);
      addLink(last,     currentPage === last);
    }

    nav.appendChild(ul);

    if (currentPage < last) {
      const aNext = document.createElement('a');
      aNext.className = 'pagination-next';
      aNext.textContent = (window.translations?.['general.pagination.next']) || 'Nächster';
      aNext.href = mkURL(currentPage + 1);
      nav.appendChild(aNext);
    }

    wrap.appendChild(nav);
    return wrap;
  }

  /* =========================
     Early ?extra merge (no nav)
  ========================== */
  (function cleanExtraParamEarly() {
    try {
      if (window.__EXTRA_MERGED_ONCE__) return;

      const qp = new URLSearchParams(location.search);
      if (!qp.has('extra')) return;

      let extra = [];
      try {
        const raw = JSON.parse(qp.get('extra') || '[]');
        if (Array.isArray(raw)) {
          extra = raw.map((s) => String(s || ''))
            .map(toHandleLoose)
            .filter(Boolean);
        }
      } catch {}

      const m = location.pathname.match(/^\/collections\/[^\/?#]+(?:\/([^\/?#]+))?/);
      const pathHandles = m && m[1] ? m[1].split('+').map(decodeURIComponent).map(toHandleLoose).filter(Boolean) : [];

      const merged = Array.from(new Set([...pathHandles, ...extra]));
      const sameAsPath = merged.length === pathHandles.length &&
                         merged.every((h, i) => h === pathHandles[i]);

      const keep = new URLSearchParams();
      ['sort_by', 'view', 'page'].forEach(k => { if (qp.has(k)) keep.set(k, qp.get(k)); });
      const basePath = (typeof COLLECTION_PATH === 'string' ? COLLECTION_PATH : (m ? m[0].split('/').slice(0,3).join('/') : location.pathname.replace(/\/[^\/?#]+$/, '')))
      const prettyPath = merged.length ? (basePath + '/' + merged.join('+')) : basePath;
      const newURL = prettyPath + (keep.toString() ? ('?' + keep.toString()) : '');

      if (!sameAsPath || qp.has('extra')) {
        window.__EXTRA_MERGED_ONCE__ = true;
        history.replaceState({}, '', newURL);
      }
    } catch {}
  })();

  /* =========================
     HTML fetch & extract
  ========================== */
  function toFrag(html) { const t = document.createElement("template"); t.innerHTML = html; return t.content; }

  function extractBitsFromFrag(frag) {
    const secDomId = window.__SECTION_DOM_ID__ || "";
    const root =
      (secDomId && frag.getElementById && frag.getElementById(secDomId)) ||
      (secDomId && frag.querySelector && frag.querySelector("#" + CSS.escape(secDomId))) ||
      frag.querySelector("[data-collection-main]")?.closest('.section, [id^="shopify-section"]') ||
      frag;

    const grid  = root.querySelector("[data-collection-main] .collection-matrix, .collection-matrix");
    const pager = root.querySelector(".paginate");
    const empty = root.querySelector(".container--no-products-in-collection");

    let pages = null, currentPage = null;
    try {
      const dataEl = root.querySelector('script[data-section-data]');
      if (dataEl?.textContent) {
        const parsed = JSON.parse(dataEl.textContent);
        if (typeof parsed?.number_of_pages === "number") pages = parsed.number_of_pages;
        if (typeof parsed?.current_page === "number") currentPage = parsed.current_page;
      }
    } catch {}

    return { grid, pager, empty, pages, currentPage, rootFrag: root instanceof DocumentFragment ? root : frag };
  }

  async function fetchBits(url) {
    const res = await fetch(url.toString(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });
    if (!res.ok) throw new Error("HTTP " + res.status);
    const html = await res.text();
    const bits = extractBitsFromFrag(toFrag(html));
    // if server indicates single page, suppress pager
    if (typeof bits.pages === 'number' && bits.pages <= 1) bits.pager = null;
    return bits;
  }

  /* =========================
     URL & selections
  ========================== */
  function urlHandlesFromPath() {
    const m = location.pathname.match(/^\/collections\/[^\/?#]+(?:\/([^\/?#]+))?/);
    if (!m || !m[1]) return [];
    return m[1].split("+").map(decodeURIComponent).map(toHandleLoose).filter(Boolean);
  }

  function buildSeoURLFromHandles(allHandles, opts) {
    const seen = new Set();
    const handles = (allHandles || [])
      .map(toHandleLoose)
      .filter(Boolean)
      .filter(h => !seen.has(h) && seen.add(h));

    const prettyPath = handles.length ? (COLLECTION_PATH + "/" + handles.join("+")) : COLLECTION_PATH;

    const pretty = new URL(prettyPath, location.origin);
    const src = new URLSearchParams(location.search);

    ["sort_by", "view"].forEach(k => { if (src.has(k)) pretty.searchParams.set(k, src.get(k)); });
    pretty.searchParams.delete("extra");

    if (opts && opts.page && Number(opts.page) > 1) {
      pretty.searchParams.set("page", String(opts.page));
    } else {
      pretty.searchParams.delete("page");
    }

    const section = new URL(pretty.href);
    if (RAW_SECTION_ID) section.searchParams.set("section_id", RAW_SECTION_ID);
    return { pretty, section };
  }

  function getElGroup(el) {
    return toHandleLoose(el.getAttribute("data-filter-group") || "tags") || "tags";
  }
  function getElValueHandle(el) {
    const a = el.getAttribute("data-filter-value");
    const b = el.getAttribute("data-pill-tag");
    const c = el.matches("[data-tag-filter-checkbox]") ? el.value : "";
    const raw = a || b || c || "";
    return toHandleLoose(raw);
  }

  function buildValueToGroupMap() {
    const map = {};
    document.querySelectorAll("[data-filter-group]").forEach((el) => {
      const v = getElValueHandle(el);
      if (!v) return;
      const g = getElGroup(el);
      map[v] = g;
    });
    return map;
  }

  function setActiveValues(activeHandles) {
    const set = new Set(activeHandles);
    document.querySelectorAll("[data-tag-filter-checkbox]").forEach((cb) => {
      const hv = toHandleLoose(cb.getAttribute("data-filter-value") || cb.value || "");
      cb.checked = hv && set.has(hv);
    });
    document.querySelectorAll(".pill-filter,[data-pill-tag]").forEach((btn) => {
      const hv = toHandleLoose(btn.getAttribute("data-pill-tag") || btn.getAttribute("data-filter-value") || "");
      const on = hv && set.has(hv);
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", String(!!on));
    });
  }

  

  function readGroupsFromDOM() {
    const map = {};
    document.querySelectorAll("[data-tag-filter-checkbox]:checked").forEach((cb) => {
      const g = getElGroup(cb);
      const v = toHandleLoose(cb.getAttribute("data-filter-value") || cb.value || "");
      if (!v) return;
      (map[g] = map[g] || []).push(v);
    });
    document.querySelectorAll(".pill-filter.is-active,[data-pill-tag].is-active").forEach((btn) => {
      const g2 = getElGroup(btn);
      const v2 = toHandleLoose(btn.getAttribute("data-filter-value") || btn.getAttribute("data-pill-tag") || "");
      if (!v2) return;
      (map[g2] = map[g2] || []).push(v2);
    });
    Object.keys(map).forEach((k) => { map[k] = Array.from(new Set(map[k])); });
    return map;
  }

  

  /** Non-badge handles only (used for URL PATH, sorting, pagination) */
  function selectedHandlesForURL() {
    const g = readGroupsFromDOM();
    const names = Object.keys(g).filter(n => n !== 'badge');  // exclude badge in path
    if (!names.length) return urlHandlesFromPath();
    return names.flatMap((n) => g[n]);
  }

  /* =========================
     Mobile drawer / group panel
  ========================== */
  function ensureGroupPanel(){
    if (groupPanel && groupPanelBackdrop) return;

    groupPanelBackdrop = document.createElement('div');
    groupPanelBackdrop.className = 'filter-group-panel__backdrop';

    groupPanel = document.createElement('div');
    groupPanel.className = 'filter-group-panel';

    var inner = document.createElement('div');
    inner.className = 'filter-group-panel__inner';

    var header = document.createElement('div');
    header.className = 'filter-group-panel__header';

    var titleEl = document.createElement('div');
    titleEl.className = 'filter-group-panel__title';
    header.appendChild(titleEl);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'filter-group-panel__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = (ICONS && ICONS.CLOSE) || '×';
    header.appendChild(closeBtn);

    var body = document.createElement('div');
    body.className = 'filter-group-panel__body';

    inner.appendChild(header);
    inner.appendChild(body);
    groupPanel.appendChild(inner);

    document.body.appendChild(groupPanelBackdrop);
    document.body.appendChild(groupPanel);

    groupPanelBackdrop.addEventListener('click', hideGroupPanel);
    closeBtn.addEventListener('click', function(e){ stop(e); hideGroupPanel(); syncGroupPillPanelState(null); });
  }

  function showGroupPanel(){
    if (!groupPanel || !groupPanelBackdrop) return;
    groupPanel.classList.remove('is-open');
    groupPanelBackdrop.classList.remove('is-open');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        groupPanel.classList.add('is-open');
        groupPanelBackdrop.classList.add('is-open');
      });
    });
  }
  function hideGroupPanel(){
    if (!groupPanel || !groupPanelBackdrop) return;
    groupPanel.classList.remove('is-open');
    groupPanelBackdrop.classList.remove('is-open');
  }
  function positionGroupPanel() {
    if (groupPanel) groupPanel.style.position = "fixed";
  }

  function getAllValuesForGroup(groupName) {
    const outSet = new Set();
    document.querySelectorAll("[data-filter-group]").forEach((el) => {
      const g = (el.getAttribute("data-filter-group") || "").trim();
      if (toHandleLoose(g) !== toHandleLoose(groupName)) return;
      const v = (el.getAttribute("data-filter-value") || el.getAttribute("data-pill-tag") || el.value || "").trim();
      if (!v) return;
      outSet.add(toHandleLoose(v));
    });
    return Array.from(outSet);
  }

  function renderGroupPanel(groupName) {
    harvestOriginalLabels(document);
    ensureGroupPanel();
    if (!groupPanel) return;

    const selectedMap = readGroupsFromDOM();
    const selectedValues = (selectedMap[groupName] || []).map(toHandleLoose);
    const allValues = getAllValuesForGroup(groupName);

    const titleEl = groupPanel.querySelector(".filter-group-panel__title");
    const body = groupPanel.querySelector(".filter-group-panel__body");

    titleEl.textContent = capFirstStrict(groupName);
    body.innerHTML = "";

    allValues.forEach((value) => {
      const row = document.createElement("label");
      row.className = "filter-group-panel__row";

      const input = document.createElement("input");
      input.type = "checkbox";
      input.className = "filter-group-panel__checkbox";
      input.setAttribute("data-panel-group", groupName);
      input.setAttribute("data-panel-value", value);
      input.checked = selectedValues.indexOf(value) !== -1;

      const span = document.createElement("span");
      span.className = "filter-group-panel__label";
      span.textContent = labelFor(value, capFirstStrict(value));


      row.appendChild(input);
      row.appendChild(span);
      body.appendChild(row);
    });

    positionGroupPanel();
    showGroupPanel();
  }

  function normalizeAccordions(root) {
    $all(".sidebar__block", root).forEach((block) => {
      const heading = block.querySelector(".sidebar-block__heading");
      const content = block.querySelector("[data-sidebar-block__content--collapsible], .sidebar-block__content");
      if (!heading || !content) return;
      if (!heading.hasAttribute("data-sidebar-block__toggle")) {
        heading.setAttribute("data-sidebar-block__toggle", "closed");
      }
      const isOpen = heading.getAttribute("data-sidebar-block__toggle") === "open";
      block.classList.toggle("acc-open", isOpen);
      content.style.display = isOpen ? "" : "none";
    });
  }

  function toggleAccordionFrom(hit) {
    const block = hit.closest(".sidebar__block");
    if (!block) return;
    const heading = block.querySelector(".sidebar-block__heading");
    const content = block.querySelector("[data-sidebar-block__content--collapsible], .sidebar-block__content");
    if (!heading || !content) return;

    const willOpen = !block.classList.contains("acc-open");

    $all(".sidebar__block.acc-open").forEach((b) => {
      if (b !== block) {
        b.classList.remove("acc-open");
        const h = b.querySelector(".sidebar-block__heading");
        if (h) h.setAttribute("data-sidebar-block__toggle", "closed");
        const c = b.querySelector("[data-sidebar-block__content--collapsible], .sidebar-block__content");
        if (c) c.style.display = "none";
      }
    });

    heading.setAttribute("data-sidebar-block__toggle", willOpen ? "open" : "closed");
    block.classList.toggle("acc-open", willOpen);
    content.style.display = willOpen ? "" : "none";
  }

  function openDrawer() { $(".filter-drawer")?.classList.add("active"); }
  function closeDrawer() { $(".filter-drawer")?.classList.remove("active"); }

  /* =========================
     Pager container & grid install
  ========================== */
  function ensureCenteredPaginateContainer(main) {
    let cont = main.querySelector('.container.container--pagination');
    if (!cont) {
      cont = document.createElement('div');
      cont.className = 'container container--pagination';
      main.appendChild(cont);
    }
    let inner = cont.querySelector('.one-whole.column.text-align-center');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'one-whole column text-align-center';
      cont.appendChild(inner);
    }
    const oldNav = inner.querySelector('nav.pagination');
    if (oldNav) oldNav.remove();
    const oldPaginate = inner.querySelector('.paginate');
    if (oldPaginate) oldPaginate.remove();
    return inner;
  }

  function removeEmptyState() {
    $all("#collection-empty-state, .container--no-products-in-collection").forEach((n) => n?.parentNode?.removeChild(n));
  }

  function renderEmptyState() {
    const curMain = $('[data-collection-main]') || $(".collection__main");
    if (!curMain) return;
    removeEmptyState();
    const curGrid = curMain.querySelector(".collection-matrix");
    const curPager = curMain.querySelector(".container--pagination");
    if (curGrid) curGrid.remove();
    if (curPager) curPager.remove();
    const empty = document.createElement("div");
    empty.id = "collection-empty-state";
    empty.className = "container container--no-products-in-collection text-align-center has-padding-bottom has-padding-top";
    empty.innerHTML = `<div class="one-whole column"><p>${NO_PRODUCTS_TEXT}</p></div>`;
    curMain.appendChild(empty);
  }

  function installBits(grid, pager, empty) {
    const curMain = $('[data-collection-main]') || $(".collection__main");
    if (!curMain) return;
    removeEmptyState();

    if (grid) {
      const curEmpty = curMain.querySelector('.container--no-products-in-collection');
      if (curEmpty) curEmpty.remove();
    }

    const curGrid = curMain.querySelector(".collection-matrix");
    if (grid) {
      const g = grid.cloneNode(true);
      curGrid ? curGrid.replaceWith(g) : curMain.appendChild(g);
    } else if (curGrid) {
      curGrid.remove();
    }

    // Determine whether to show pagination
    let showPager = !!pager;
    try {
      const tmp = pager ? pager.cloneNode(true) : null;
      const attrPages = tmp ? Number(tmp.getAttribute('data-paginate-pages') || '0') : 0;
      if (attrPages > 0) {
        showPager = attrPages > 1;
      } else if (grid) {
        const cnt = grid.children ? grid.children.length : 0;
        const per = (PER_PAGE != null && !isNaN(PER_PAGE)) ? PER_PAGE : cnt + 1;
        showPager = cnt > per; // only when strictly more than one page worth
        if (cnt <= per) showPager = false;
      }
    } catch {}

    const prevCont = curMain.querySelector('.container.container--pagination');
    if (prevCont) prevCont.remove();

    if (showPager && pager) {
      const inner = ensureCenteredPaginateContainer(curMain);
      const cloned = pager.cloneNode(true);
      if (!cloned.getAttribute('data-paginate-pages')) {
        try {
          const nums = Array.from(cloned.querySelectorAll('.pagination-link'))
            .map(a => parseInt(a.textContent.trim(), 10))
            .filter(n => !isNaN(n));
          if (nums.length) cloned.setAttribute('data-paginate-pages', String(Math.max(...nums)));
        } catch {}
      }
      inner.appendChild(cloned);
      cachePagerFrom(pager);
    } else {
      try {
        const u = new URL(location.href);
        if (u.searchParams.has('page')) {
          u.searchParams.delete('page'); // only one page → drop page param
          history.replaceState({}, '', u.pathname + u.search);
        }
      } catch {}
    }

    try { reinitFlexGrid(); } catch {}
    fixPaginationLinksForCurrentSelection();
    normalizePageInURL(); // ensure URL page is valid if pager exists
  }

  function installGridFromTiles(unionTiles, pagerEl) {
    const main = document.querySelector('[data-collection-main]') || document.querySelector('.collection__main');
    if (!main) return;

    let wrap = main.querySelector('.collection-matrix__wrapper');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'collection-matrix__wrapper';
      const loader = document.createElement('div');
      loader.className = 'collection__loading-icon button is-loading is-loading--icon-only';
      wrap.appendChild(loader);
      main.prepend(wrap);
    } else {
      const empty = main.querySelector('.container--no-products-in-collection');
      if (empty) empty.remove();
    }

    let grid = wrap.querySelector('.container.collection-matrix');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'container collection-matrix';
      wrap.appendChild(grid);
    }
    grid.innerHTML = '';
    unionTiles.forEach(t => grid.appendChild(t.node.cloneNode(true)));

    const prevCont = main.querySelector('.container.container--pagination');
    if (prevCont) prevCont.remove();

    if (pagerEl) {
      const inner = ensureCenteredPaginateContainer(main);
      inner.appendChild(pagerEl.cloneNode(true));
      cachePagerFrom(pagerEl || document);
    } else {
      try {
        const u = new URL(location.href);
        if (u.searchParams.has('page')) {
          u.searchParams.delete('page');
          history.replaceState({}, '', u.pathname + u.search);
        }
      } catch {}
    }

    try { reinitFlexGrid(); } catch {}
    fixPaginationLinksForCurrentSelection();
    normalizePageInURL();
  }

  function collectTilesFromGrid(gridEl) {
    if (!gridEl) return [];
    return Array.from(gridEl.children || []).map((el) => {
      const a = el.querySelector('a[href*="/products/"]');
      const href = a ? a.getAttribute("href") : "";
      const m = href && href.match(/\/products\/[^\/?#]+/);
      const key = m ? m[0] : href || Math.random().toString(36).slice(2);
      return { key, node: el };
    });
  }

  function normalizePageInURL(){
    try {
      const paginate = document.querySelector('.paginate');
      if (!paginate) return;

      const total = Math.max(1, Number(paginate.getAttribute('data-paginate-pages') || '1') || 1);
      const u = new URL(location.href);
      const p = Math.max(1, Number(u.searchParams.get('page') || '1') || 1);

      if (p > total) {
        // Clamp to last page rather than dropping the param
        u.searchParams.set('page', String(total));
        history.replaceState({}, '', u.pathname + u.search);
      }
    } catch {}
  }
  

  /* =========================
     Theme re-init
  ========================== */
  function reinitFlexGrid() {
    try {
      window.theme?.ProductCard?.init?.();
      window.theme?.ProductGrid?.init?.();
      window.theme?.QuickShop?.init?.();
      window.theme?.QuickAdd?.init?.();
      window.theme?.Tooltip?.init?.();
      window.PXUTheme?.jsCollection?.init?.();
      window.PXUTheme?.jsProduct?.init?.();
      if (window.Theme?.init) window.Theme.init();
      document.dispatchEvent(new Event("product-grid:updated"));
      document.dispatchEvent(new CustomEvent("theme:section:load", {
        detail: { sectionId: (window.__SECTION_DOM_ID__ || "").replace("shopify-section-", "") }
      }));
    } catch {}
  }

  /* =========================
     UNION pagination (AND across groups, OR within each group)
  ========================== */
  async function buildUnionAtPage(page, gmap) {
    const LIMIT = await ensurePerPage();
    const START = (Number(page) - 1) * LIMIT;

    // IMPORTANT: cartesian of groups means AND across groups
    const names = Object.keys(gmap);
    const combos = names.length
      ? names.reduce((acc, g) => acc.flatMap(c => gmap[g].map(v => c.concat([v]))), [[]])
      : [[]];

    const sources = combos.slice(0, 128);
    const perSourceTotals = new Map();
    const perSourceTiles  = new Map();
    const keyOf = (src) => JSON.stringify(src);

   async function fetchOne(srcHandles, pageNum) {
  // Split the source handles into "badge tags" (exact tags only) and "others"
  const badgesExact = [];
  const others = [];
  srcHandles.map(toHandleLoose).forEach(h => {
    if (ALL_BADGE_FILTER_TAGS.has(h)) badgesExact.push(h);
    else others.push(h);
  });

  const urls = buildSeoURLFromHandles(srcHandles, { page: pageNum });

  // If we have any real badge tags, force server-side tag constraint:
  // constraint = <others + exact badge tags>, joined with '+'
  let targetURL;
  if (badgesExact.length > 0) {
    const base = buildSeoURLFromHandles([], { page: pageNum });
    targetURL = new URL(base.section);
    const constraintParts = [...others, ...badgesExact].map(toHandleLoose).filter(Boolean);
    targetURL.searchParams.set('constraint', constraintParts.join('+'));
  } else {
    // No badges → normal themed fetch with handles in the path
    targetURL = new URL(urls.section);
  }

  const curSort = (new URL(location.href)).searchParams.get('sort_by');
  if (curSort) targetURL.searchParams.set('sort_by', curSort);

  const bits = await fetchBits(targetURL);
  if (bits?.pager) cachePagerFrom(bits.rootFrag || bits.pager);

  const tiles = bits?.grid ? collectTilesFromGrid(bits.grid) : [];
  const total = (typeof bits?.pages === "number" && bits.pages > 0) ? bits.pages : 1;
  return { tiles, totalPages: total };
}


    // prefetch page 1 of each source
    await Promise.all(sources.map(async (src) => {
      const res = await fetchOne(src, 1);
      perSourceTotals.set(keyOf(src), res.totalPages);
      perSourceTiles.set(keyOf(src) + "|1", res.tiles);
    }));

    // fetch remaining pages per source
    await Promise.all(sources.map(async (src) => {
      const k = keyOf(src);
      const total = perSourceTotals.get(k) || 1;
      for (let p = 2; p <= total; p++) {
        const res = await fetchOne(src, p);
        perSourceTiles.set(k + "|" + p, res.tiles);
      }
    }));

    // interleave, de-duplicate by product key
    const seen = new Set();
    a:
    for (let p = 1; p <= Math.max(1, ...Array.from(perSourceTotals.values())); p++) {
      for (const src of sources) {
        const tiles = perSourceTiles.get(keyOf(src) + "|" + p) || [];
        for (const t of tiles) {
          if (!seen.has(t.key)) { seen.add(t.key); }
        }
      }
    }
    // flatten order: same interleaving as above but collecting nodes
    const stream = [];
    const maxPagesAmongSources = Math.max(1, ...Array.from(perSourceTotals.values()));
    for (let p = 1; p <= maxPagesAmongSources; p++) {
      for (const src of sources) {
        const tiles = perSourceTiles.get(keyOf(src) + "|" + p) || [];
        for (const t of tiles) {
          if (!stream.find(x => x.key === t.key)) stream.push(t);
        }
      }
    }

    const totalItems  = stream.length;
    const totalPages  = Math.max(1, Math.ceil(totalItems / LIMIT));
    const currentPage = Math.min(Math.max(1, Number(page)), totalPages);
    const slice       = stream.slice(START, Math.min(stream.length, START + LIMIT));
    const pagerEl     = buildThemePagerWindow(currentPage, totalPages);
    return { unionTiles: slice, pagerEl };
  }

  /* =========================
     Active pill UI (top rows)
  ========================== */
  function ensureActivePillContainers() {
    let topRow = document.querySelector(".active-groups-inline");
    let bottomRow = document.querySelector(".active-values-wrap");
    if (!topRow) { topRow = document.createElement("div"); topRow.className = "active-groups-inline"; $(".filters-pill-row-top")?.appendChild(topRow); }
    if (!bottomRow) { bottomRow = document.createElement("div"); bottomRow.className = "active-values-wrap"; $(".filters-pill-row-bottom")?.appendChild(bottomRow); }
    let groupHolder = document.querySelector("[data-active-pill-groups]");
    let valueHolder = document.querySelector("[data-active-pill-values]");
    if (!groupHolder) { groupHolder = document.createElement("div"); groupHolder.setAttribute("data-active-pill-groups", ""); topRow.appendChild(groupHolder); }
    if (!valueHolder) { valueHolder = document.createElement("div"); valueHolder.setAttribute("data-active-pill-values", ""); bottomRow.appendChild(valueHolder); }
    return { groupHolder, valueHolder };
  }

  function refreshBadgePillIcons() {
    $all('.pill-filter[data-filter-group="badge"]').forEach((btn) => {
      $all(".pill-icon", btn).forEach((n) => n.remove());
      if (btn.classList.contains("is-active")) {
        const span = document.createElement("span");
        span.className = "pill-icon pill-icon--close";
        span.setAttribute("aria-hidden", "true");
        span.innerHTML = ICONS.CLOSE || '×';
        btn.appendChild(span);
      }
    });
  }

  function syncGroupPillPanelState(forceKeepOpenBtn) {
    $all(".active-group-pill").forEach((p) => {
      if (forceKeepOpenBtn && p === forceKeepOpenBtn) return;
      p.classList.remove("is-panel-open");
      const lbl = p.querySelector(".active-group-pill__label");
      const ico = p.querySelector(".active-group-pill__icon");
      lbl?.classList.remove("active");
      if (ico) { ico.classList.remove("active"); ico.innerHTML = ICONS.CARET; }
    });
    if (!forceKeepOpenBtn) CURRENT_OPEN_GROUP = null;
  }

  function getAllGroupNames() {
    const set = new Set();
    document.querySelectorAll('[data-tag-filter-checkbox], [data-pill-tag], [data-filter-value]').forEach(el => {
      const g = (el.getAttribute('data-filter-group') || '').trim();
      const val = (el.getAttribute('data-filter-value') || el.getAttribute('data-pill-tag') || el.value || '').trim();
      if (g && val) set.add(toHandleLoose(g));
    });
    return Array.from(set);
  }

  function renderActivePills() {
    const { groupHolder, valueHolder } = ensureActivePillContainers();
    if (!groupHolder || !valueHolder) return;

    const selectedMap = readGroupsFromDOM();
    const allGroups = getAllGroupNames();

    groupHolder.innerHTML = "";
    valueHolder.innerHTML = "";

    allGroups.forEach((groupName) => {
      if (groupName === "badge") return;

      const valuesSelected = selectedMap[groupName] || [];
      const gBtn = document.createElement("button");
      gBtn.type = "button";
      gBtn.className = "pill-filter active-group-pill";
      if (valuesSelected.length > 0) gBtn.classList.add("is-active");
      gBtn.setAttribute("data-active-group", groupName);

      const labelSpan = document.createElement("span");
      labelSpan.className = "active-group-pill__label";
      labelSpan.textContent = capFirstStrict(groupName);

      let countSpan = null;
      if (valuesSelected.length >= 1) {
        countSpan = document.createElement("span");
        countSpan.className = "active-group-pill__count";
        countSpan.textContent = String(valuesSelected.length);
      }

      const iconSpan = document.createElement("span");
      iconSpan.className = "active-group-pill__icon";
      iconSpan.setAttribute("aria-hidden", "true");

      const panelOpen = (CURRENT_OPEN_GROUP === groupName);
      if (panelOpen) gBtn.classList.add("is-panel-open");
      iconSpan.innerHTML = panelOpen ? (ICONS.CLOSE || '×') : (ICONS.CARET || '');

      if (countSpan) { gBtn.appendChild(countSpan); gBtn.appendChild(labelSpan); }
      else { gBtn.appendChild(labelSpan); }
      gBtn.appendChild(iconSpan);

      if (panelOpen) { labelSpan.classList.add("active"); iconSpan.classList.add("active"); }

      groupHolder.appendChild(gBtn);

      wakeHorizontalPillsScroll();

    });

    Object.keys(selectedMap).forEach((groupName) => {
      const valuesSelected = selectedMap[groupName] || [];
      valuesSelected.forEach((value) => {
        const vBtn = document.createElement("button");
        vBtn.type = "button";
        vBtn.className = "pill-filter is-active active-value-pill";
        vBtn.setAttribute("data-active-group", groupName);
        vBtn.setAttribute("data-active-value", value);

        const textSpan = document.createElement("span");
        textSpan.className = "active-value-pill__text";
        textSpan.textContent = labelFor(value, capFirstStrict(value));


        const closeSpan = document.createElement("span");
        closeSpan.className = "active-value-pill__close";
        closeSpan.setAttribute("aria-hidden", "true");
        closeSpan.innerHTML = ICONS.CLOSE || '×';

        vBtn.appendChild(textSpan);
        vBtn.appendChild(closeSpan);
        valueHolder.appendChild(vBtn);
      });
    });

    refreshBadgePillIcons();
  }


  /* =========================
     BADGE aliases (robust defaults)
  ========================== */
// Exact tag handles to use for filtering (ONLY real tags that exist on products)
const BADGE_FILTER_TAGS = {
  raritaten: [
    'raritäten', 'raritaten', 'tee-raritäten', 'tee-raritaten',
    'raritaten-gruntee-china', 'raritat'
  ],
  neuheiten: [
    // Only the exact tag that marks new items
    'tee-neuheiten', 'new'
  ],
  bestseller: [
    // Only the exact tag that marks bestsellers
    'bestseller'
  ]
};

// Quick helper: flatten all badge filter tags into a Set for lookups
// Quick helper: flatten all badge filter tags into a Set for lookups
const ALL_BADGE_FILTER_TAGS = new Set(
  Object.values(BADGE_FILTER_TAGS).flat().map(toHandleLoose)
);

/* === SHIM: define BADGE_ALIASES from BADGE_FILTER_TAGS (surgical) === */
const BADGE_ALIASES = (function(){
  try {
    const out = {};
    Object.keys(BADGE_FILTER_TAGS || {}).forEach(key => {
      const canon = toHandleLoose(key);
      const variants = (BADGE_FILTER_TAGS[key] || []).map(toHandleLoose);
      // include the key itself and dedupe
      out[canon] = Array.from(new Set([canon, ...variants])).filter(Boolean);
    });
    return out;
  } catch { return {}; }
})();



  // Blocked options (hidden from UI)
const BLOCKED = new Set([
  'sri-lanka',
  'wellness',
  'ayurveda',
  'lifestyle',
  'detox',
  'eistee'
]);

// NEW: pages where Volumen/Material are allowed
const WHITELIST_GROUP_PAGES = Array.from(new Set([
  '/collections/zubehor-feinkost',
  '/collections/teekannen',
  '/collections/teetassen',
  '/collections/teesiebe-filter',
  '/collections/matcha-zubehor',
  '/collections/karaffen',
  '/collections/dosen',
  '/collections/diverses',
  '/collections/susses',
  '/collections/chanoyu-japanische-teezeremonie',
  '/collections/gong-fu-cha'
].map(s => s.replace(/[.]+$/,'').replace(/\/$/,'').toLowerCase())));


function isBlocked(value) {
  // Safer: normalize, guard falsy, avoid throwing
  try {
    const v = toHandleLoose(value || '');
    if (!v) return false;        // don't block empties/undefined
    return BLOCKED.has(v);
  } catch {
    return false;
  }
}



// NEW: group-level blocking (Volumen, Material)
const BLOCKED_GROUPS = new Set();
(function initBlockedGroups(){
  const curPath = (typeof COLLECTION_PATH === 'string' ? COLLECTION_PATH : location.pathname)
    .replace(/[.]+$/,'').replace(/\/$/,'').toLowerCase();

  // Only allow Volumen/Material on the whitelisted pages
  if (!WHITELIST_GROUP_PAGES.includes(curPath)) {
    BLOCKED_GROUPS.add('volumen');
    BLOCKED_GROUPS.add('material');
  }
})();

function hideBlockedOptionsInDOM() {
  try {
    // 1) Remove anything that belongs to a blocked GROUP (e.g., Volumen / Material)
    $all('[data-filter-group]').forEach((el) => {
      const g = toHandleLoose(el.getAttribute('data-filter-group') || '');
      if (!g) return;
      if (BLOCKED_GROUPS && BLOCKED_GROUPS.has && BLOCKED_GROUPS.has(g)) {
        const row =
          el.closest(
            '.filter-group-panel__row, label, li, .tag-list-item, .pill-filter, .faceted-filter-group, .sidebar__block'
          ) || el;
        row.remove();
      }
    });

    // 2) Remove individual blocked VALUES (scope to sidebar/panel only so we don't touch product grid)
    $all(
      '.sidebar [data-filter-group][data-filter-value], ' +
      '.sidebar [data-pill-tag], ' +
      '.filter-group-panel [data-filter-group][data-filter-value], ' +
      '.filter-group-panel [data-pill-tag]'
    ).forEach((el) => {
      const v = getElValueHandle(el);
      if (!v) return;
      if (isBlocked(v)) {
        const row =
          el.closest('.filter-group-panel__row, label, li, .tag-list-item, .pill-filter') || el;
        row.remove();
      }
    });

    // 3) If the desktop sidebar is now empty, insert a tiny "ghost" block
    //    to preserve the left column and prevent the grid from stretching full-width.
    const sidebar =
      document.querySelector('.collection__sidebar') ||
      document.querySelector('.sidebar') ||
      document.querySelector('.collection-sidebar');

    if (sidebar) {
      const hasRealBlock = !!sidebar.querySelector('.sidebar__block');
      if (!hasRealBlock) {
        const ghost = document.createElement('div');
        ghost.className = 'sidebar__block sidebar__block--ghost';
        ghost.style.minHeight = '1px';
        ghost.style.visibility = 'hidden';
        sidebar.appendChild(ghost);
      }
    }

    // 4) Optional tidy: remove *empty* sidebar blocks, but never remove the last one (or the ghost).
    if (sidebar) {
      const blocks = Array.from(sidebar.querySelectorAll('.sidebar__block'))
        .filter(Boolean);
      if (blocks.length > 1) {
        blocks.forEach((blk) => {
          const hasOption =
            blk.querySelector('[data-filter-group],[data-pill-tag],[data-filter-value]');
          const isGhost = blk.classList.contains('sidebar__block--ghost');
          if (!hasOption && !isGhost && blocks.length > 1) {
            blk.remove();
          }
        });
      }
    }

    // 5) After DOM changes, wake horizontal pill rails (mobile nicety)
    if (typeof wakeHorizontalPillsScroll === 'function') {
      wakeHorizontalPillsScroll();
    }
  } catch (e) {
    // Fail-safe: never break the page if something unexpected happens
    console.warn('hideBlockedOptionsInDOM():', e);
  }
}




  /* =========================
     Main apply (filters)
  ========================== */
 // ⬇️ Replace your entire window.applyFilters with this version
window.applyFilters = async function () {
  const myTurn = ++applySeq;
  const loader = $(".collection__loading-icon");
  if (loader) loader.style.display = "";

  try {
    await ensurePerPage();

    let groups = readGroupsFromDOM();

    // Sync badges from URL if none toggled yet (direct links / pagination refresh)
    if (!groups.badge || groups.badge.length === 0) {
      const fromURL = getBadgesFromURL();
      if (fromURL.length) {
        fromURL.forEach(b=>{
          const btn = document.querySelector('.pill-filter[data-filter-group="badge"][data-filter-value="'+b+'"]');
          if (btn && !btn.classList.contains('is-active')) {
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
          }
        });
        groups = readGroupsFromDOM();
      }
    }

    // Expand ALL selected badges -> OR over union of all their aliases (strict lists you defined)
   if (groups.badge && groups.badge.length) {
      const strict = [];
      groups.badge.forEach(b => {
        const canon = toHandleLoose(b);
        const exactTags = BADGE_FILTER_TAGS[canon] || [];
        strict.push(...exactTags);
      });
      // only exact, real tags go forward to the UNION builder
      groups.badge = Array.from(new Set(strict.map(toHandleLoose)));
    }

    renderActivePills();

    // Reset ?page to 1 when the selection truly changes
    try {
      const nowKey = makeSelectionKey(readGroupsFromDOM());
      if (__LAST_SELECTION_KEY__ !== nowKey) {
        __LAST_SELECTION_KEY__ = nowKey;
        const u = new URL(location.href);
        if (u.searchParams.has('page')) {
          u.searchParams.delete('page');
          history.replaceState({}, '', u.pathname + u.search);
        }
      }
    } catch {}

    const selectedCount = Object.values(groups).reduce((n, arr) => n + (arr?.length || 0), 0);

    // Nothing selected → collapse to base collection (keep sort/badge params)
    if (selectedCount === 0) {
      const base = buildSeoURLFromHandles([], {});
      const fetchURL = new URL(base.section);
      const prettyURL = new URL(base.pretty);

      const cur = new URL(location.href);
      const curSort = cur.searchParams.get('sort_by');
      if (curSort) { fetchURL.searchParams.set('sort_by', curSort); prettyURL.searchParams.set('sort_by', curSort); }
      setBadgesInURL(prettyURL, getBadgesFromURL());

      const bits = await fetchBits(fetchURL);
      if (myTurn !== applySeq) return;

      history.replaceState({}, "", prettyURL.pathname + prettyURL.search);
      if (bits.empty || !bits.grid) renderEmptyState();
      else installBits(bits.grid, bits.pager, bits.empty);

      normalizePageInURL();
      return;
    }

    const allGroupNames = Object.keys(groups).filter((g) => groups[g] && groups[g].length);
    const nonBadgeNames = allGroupNames.filter(g => g !== 'badge');
    const nonBadgeHandles = nonBadgeNames.flatMap(g => groups[g] || []);

    const targetPage = getPageFromURL();
    const curSort = (new URL(location.href)).searchParams.get('sort_by');

    await ensurePagerTemplate();

    // CASE A: only badges selected → UNION on client with server constraints
    if (nonBadgeHandles.length === 0 && (groups.badge?.length || 0) > 0) {
      const { unionTiles, pagerEl } = await buildUnionAtPage(targetPage, groups);
      if (myTurn !== applySeq) return;

      // preserve any handles already in path (usually none)
      const pathHandles = urlHandlesFromPath();
      const prettyBase = buildSeoURLFromHandles(pathHandles, { page: targetPage }).pretty;

      const u = new URL(prettyBase.href);
      if (curSort) u.searchParams.set('sort_by', curSort);

      // put ONLY the raw badge keys (not aliases) back into the URL
      const rawKeys = (readGroupsFromDOM().badge || []).map(toHandleLoose);
      setBadgesInURL(u, rawKeys);

      history.replaceState({}, "", u.pathname + u.search);
      if (!unionTiles.length) renderEmptyState(); else installGridFromTiles(unionTiles, pagerEl);
      return;
    }

    // ✅ CASE B: exactly one non-badge handle
    // If a badge is present, we MUST still run the UNION path so the badge
    // constraint (e.g. 'tee-neuheiten') is respected by Shopify.
    if (nonBadgeHandles.length === 1) {
      const haveBadges = (groups.badge?.length || 0) > 0;

      if (haveBadges) {
        const { unionTiles, pagerEl } = await buildUnionAtPage(targetPage, groups);
        if (myTurn !== applySeq) return;

        const prettyBase = buildSeoURLFromHandles([nonBadgeHandles[0]], { page: targetPage }).pretty;
        const u = new URL(prettyBase.href);
        if (curSort) u.searchParams.set('sort_by', curSort);

        // keep ONLY the raw selected badge keys (not aliases) in the URL
        const rawKeys = (readGroupsFromDOM().badge || []).map(toHandleLoose);
        setBadgesInURL(u, rawKeys);

        history.replaceState({}, "", u.pathname + u.search);
        if (!unionTiles.length) renderEmptyState(); else installGridFromTiles(unionTiles, pagerEl);
        normalizePageInURL();
        return;
      }

      // No badges → simple server fetch is fine
      const urls = buildSeoURLFromHandles([nonBadgeHandles[0]], { page: targetPage });
      const secURL = new URL(urls.section);
      if (curSort) secURL.searchParams.set('sort_by', curSort);

      const bits = await fetchBits(secURL);
      if (myTurn !== applySeq) return;

      const prettyURL = new URL(urls.pretty);
      if (curSort) prettyURL.searchParams.set('sort_by', curSort);
      const rawKeys = (readGroupsFromDOM().badge || []).map(toHandleLoose);
      setBadgesInURL(prettyURL, rawKeys);
      history.replaceState({}, "", prettyURL.pathname + prettyURL.search);

      if (bits.empty || !bits.grid) renderEmptyState(); else installBits(bits.grid, bits.pager, bits.empty);
      normalizePageInURL();
      return;
    }

    // CASE C: multiple non-badge handles → client UNION (plus badges)
    {
      const { unionTiles, pagerEl } = await buildUnionAtPage(targetPage, groups);
      if (myTurn !== applySeq) return;

      const prettyBase = buildSeoURLFromHandles(nonBadgeHandles, { page: targetPage }).pretty;
      const u = new URL(prettyBase.href);
      if (curSort) u.searchParams.set('sort_by', curSort);
      const rawKeys = (readGroupsFromDOM().badge || []).map(toHandleLoose);
      setBadgesInURL(u, rawKeys);
      history.replaceState({}, "", u.pathname + u.search);

      if (!unionTiles.length) renderEmptyState(); else installGridFromTiles(unionTiles, pagerEl);
      normalizePageInURL();
    }

  } catch {
    renderEmptyState();
  } finally {
    const hasGrid = !!(document.querySelector('[data-collection-main] .collection-matrix') || document.querySelector('.collection__main .collection-matrix'));
    if (hasGrid) {
      const dangling = document.querySelector('.container--no-products-in-collection');
      if (dangling) dangling.remove();
    }
    fixPaginationLinksForCurrentSelection();
    if (loader) loader.style.display = "none";
    __BOOT_DONE__ = true;
    __IS_INITIAL_HYDRATE__ = false;
    document.documentElement.removeAttribute('data-coll-pending');
  }
};


  /* =========================
     Sorting
  ========================== */
  async function applySort(sortValue) {
    const handles = selectedHandlesForURL(); // non-badge only
    const pretty = buildSeoURLFromHandles(handles, {});
    pretty.pretty.searchParams.set("sort_by", sortValue);

    // carry badges
    setBadgesInURL(pretty.pretty, getBadgesFromURL());

    const sectionURL = new URL(pretty.pretty.href);
    if (RAW_SECTION_ID) sectionURL.searchParams.set("section_id", RAW_SECTION_ID);

    const pathHandles = urlHandlesFromPath();
    if (pathHandles.length) {
      const pathIsBadge = Object.keys(BADGE_ALIASES).some(key =>
        pathHandles.some(h => BADGE_ALIASES[key].includes(h))
      );
      if (pathIsBadge) {
        coercePathBadgeToQuery();
        // re-sync badges from URL to DOM pills
        const fromURL = getBadgesFromURL();
        fromURL.forEach(b=>{
          const btn = document.querySelector(`.pill-filter[data-filter-group="badge"][data-filter-value="${b}"]`);
          if (btn && !btn.classList.contains('is-active')) {
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
          }
        });
      }
    }

    const loader = $(".collection__loading-icon");
    if (loader) loader.style.display = "";
    try {
      const g = readGroupsFromDOM();
      const totalSelected = Object.values(g).reduce((n, arr)=>n+(arr?.length||0),0);
      const nonBadgeCount = (Object.keys(g).filter(k=>k!=='badge').reduce((n,k)=>n+(g[k]?.length||0),0));

      history.replaceState({}, "", pretty.pretty.pathname + pretty.pretty.search);

      if (nonBadgeCount > 1 || (nonBadgeCount===0 && (g.badge?.length||0)>0) || totalSelected > 1) {
        await window.applyFilters();
        return;
      }

      const bits = await fetchBits(sectionURL);
      if (bits.empty && !bits.grid) renderEmptyState();
      else installBits(bits.grid, bits.pager, bits.empty);
      normalizePageInURL();
    } catch {
      renderEmptyState();
    } finally {
      if (loader) loader.style.display = "none";
    }
  }

  /* =========================
     Pagination link fixup
  ========================== */
  function fixPaginationLinksForCurrentSelection() {
    const paginate = document.querySelector(".paginate");
    if (!paginate) return;

    const handles = selectedHandlesForURL();
    const base = buildSeoURLFromHandles(handles, {});
    const basePretty = new URL(base.pretty.href);

    const badges = getBadgesFromURL();
    const sort = (new URL(location.href)).searchParams.get('sort_by');

    $all('nav.pagination ul a[href]', paginate).forEach(a => {
      try {
        const textNum = (a.textContent || '').trim();
        const href = a.getAttribute('href') || '';
        const u = new URL(href, location.href);
        let page = u.searchParams.get('page');
        if (!page && /^\d+$/.test(textNum)) page = textNum;
        if (!page) return;
        const target = new URL(basePretty.href);
        if (Number(page) > 1) target.searchParams.set('page', String(page));
        else target.searchParams.delete('page');
        setBadgesInURL(target, badges);
        if (sort) target.searchParams.set('sort_by', sort);
        a.setAttribute('href', target.pathname + target.search);
      } catch {}
    });

    $all('.pagination-previous[href], .pagination-next[href]', paginate).forEach(a => {
      try {
        const u = new URL(a.getAttribute('href'), location.href);
        const page = u.searchParams.get('page');
        if (!page) return;
        const target = new URL(basePretty.href);
        if (Number(page) > 1) target.searchParams.set('page', String(page));
        else target.searchParams.delete('page');
        setBadgesInURL(target, badges);
        if (sort) target.searchParams.set('sort_by', sort);
        a.setAttribute('href', target.pathname + target.search);
      } catch {}
    });
  }

  /* =========================
     Delegated events
  ========================== */
  (function bindDelegatedEvents() {
    if (window.__FILTER_EVENTS_BOUND__) return;
    window.__FILTER_EVENTS_BOUND__ = true;

    document.addEventListener("click", (e) => {
      const inGroupPanel = !!e.target.closest(".filter-group-panel");

      const openBtn = e.target.closest(".filter_title");
      if (openBtn) { stop(e); openDrawer(); return; }

      const sideCloseBtn = (!inGroupPanel && (e.target.closest(".filter-close") || e.target.closest(".closeDrawer"))) ? true : false;
      if (sideCloseBtn) { stop(e); closeDrawer(); return; }

      const accHit = e.target.closest(".sidebar-block__heading, .sidebar-block__toggle, .sidebar-block__toggle-icon");
      if (accHit) { stop(e); toggleAccordionFrom(accHit); return; }

      const valPill = e.target.closest(".active-value-pill");
        if (valPill) {
        stop(e);
        const gV = valPill.getAttribute("data-active-group");
        const vV = valPill.getAttribute("data-active-value");
        // uncheck matching controls
        $all("[data-tag-filter-checkbox][data-filter-group]").forEach((cb) => {
            const g = toHandleLoose(cb.getAttribute("data-filter-group") || "");
            const v = toHandleLoose(cb.getAttribute("data-filter-value") || cb.value || "");
            if (g === toHandleLoose(gV) && v === toHandleLoose(vV)) cb.checked = false;
        });
        $all(".pill-filter.is-active,[data-pill-tag].is-active").forEach((btn) => {
            const g2 = toHandleLoose(btn.getAttribute("data-filter-group") || "");
            const v2 = toHandleLoose(btn.getAttribute("data-filter-value") || btn.getAttribute("data-pill-tag") || "");
            if (g2 === toHandleLoose(gV) && v2 === toHandleLoose(vV)) {
            btn.classList.remove("is-active"); btn.setAttribute("aria-pressed", "false");
            }
        });

        // 👉 add this block:
        try {
            // after toggling UI, recompute current badges and reflect them in the URL
            const current = readGroupsFromDOM();
            const activeBadges = (current.badge || []).map(toHandleLoose).filter(Boolean);

            const u = new URL(location.href);
            if (activeBadges.length) u.searchParams.set('badge', activeBadges.join(','));
            else u.searchParams.delete('badge');     // ← this prevents re-hydration of the last pill

            u.searchParams.delete('page');           // reset pagination on selection change
            history.replaceState({}, '', u.pathname + u.search);
        } catch {}

        window.applyFilters?.();
        renderActivePills();
        return;
        }


      const grpPill = e.target.closest(".active-group-pill");
      if (grpPill) {
        stop(e);
        const groupName = grpPill.getAttribute("data-active-group");
        const isOpen = grpPill.classList.contains("is-panel-open");
        if (isOpen) {
          grpPill.classList.remove("is-panel-open");
          grpPill.querySelector(".active-group-pill__label")?.classList.remove("active");
          const ico = grpPill.querySelector(".active-group-pill__icon");
          if (ico) { ico.classList.remove("active"); ico.innerHTML = ICONS.CARET || ''; }
          hideGroupPanel();
          CURRENT_OPEN_GROUP = null;
          syncGroupPillPanelState(null);
        } else {
          CURRENT_OPEN_GROUP = groupName;
          syncGroupPillPanelState(grpPill);
          grpPill.classList.add("is-panel-open");
          grpPill.querySelector(".active-group-pill__label")?.classList.add("active");
          const ico = grpPill.querySelector(".active-group-pill__icon");
          if (ico) { ico.classList.add("active"); ico.innerHTML = ICONS.CLOSE || '×'; }
          renderGroupPanel(groupName);
        }
        return;
      }

      const backdropHit = e.target.closest(".filter-group-panel__backdrop");
      if (backdropHit) {
        stop(e);
        hideGroupPanel();
        CURRENT_OPEN_GROUP = null;
        syncGroupPillPanelState(null);
        return;
      }

      const pageLink = e.target.closest(".paginate a[href]");
      if (pageLink) {
        stop(e);
        let targetPage = null;
        try {
          const u = new URL(pageLink.getAttribute("href"), location.href);
          targetPage = u.searchParams.get("page") || "1";
        } catch {}
        if (!targetPage) return;

        // Build group map fresh (so we respect current UI)
        const g = readGroupsFromDOM();

        // expand badges for strict AND matching
        // expand badges for strict AND matching (use exact real tags)
        if (g.badge && g.badge.length) {
        const merged = [];
        g.badge.forEach(b => {
            const key = toHandleLoose(b);
            merged.push(...(BADGE_FILTER_TAGS[key] || [key])); // strict tags only
        });
        g.badge = Array.from(new Set(merged.map(toHandleLoose)));
        }


        const nonBadgeCount = Object.keys(g).filter(k => k!=='badge').reduce((n, k) => n + (g[k]?.length || 0), 0);
        const totalSelected = Object.values(g).reduce((n, arr)=>n+(arr?.length||0),0);

        const urls = buildSeoURLFromHandles(Object.keys(g).filter(k=>k!=='badge').flatMap(k => g[k]||[]), { page: Number(targetPage) });
        const loader = $(".collection__loading-icon"); if (loader) loader.style.display = "";

        // UNION for: (badge-only) OR (multi-non-badge) OR (multi total)
        if ((nonBadgeCount === 0 && (g.badge?.length||0) > 0) || nonBadgeCount > 1 || totalSelected > 1) {
          buildUnionAtPage(Number(targetPage), g).then(({ unionTiles, pagerEl }) => {
            const prettyURL = new URL(urls.pretty);
            setBadgesInURL(prettyURL, (readGroupsFromDOM().badge||[]));
            history.pushState({}, "", prettyURL.pathname + prettyURL.search);
            if (!unionTiles.length) renderEmptyState();
            else installGridFromTiles(unionTiles, pagerEl);
            normalizePageInURL();
          }).catch(() => {
            const prettyURL = new URL(urls.pretty);
            setBadgesInURL(prettyURL, (readGroupsFromDOM().badge||[]));
            location.assign(prettyURL.pathname + prettyURL.search);
          }).finally(() => { if (loader) loader.style.display = "none"; });
        } else {
          // Single non-badge → server fetch
          const secURL = new URL(urls.section);
          fetchBits(secURL).then((bits) => {
            const prettyURL = new URL(urls.pretty);
            setBadgesInURL(prettyURL, (readGroupsFromDOM().badge||[]));
            history.pushState({}, "", prettyURL.pathname + prettyURL.search);
            if (bits.empty && !bits.grid) renderEmptyState();
            else installBits(bits.grid, bits.pager, bits.empty);
            normalizePageInURL();
          }).catch(() => {
            const prettyURL = new URL(urls.pretty);
            setBadgesInURL(prettyURL, (readGroupsFromDOM().badge||[]));
            location.assign(prettyURL.pathname + prettyURL.search);
          }).finally(() => { if (loader) loader.style.display = "none"; });
        }
        return;
      }

      const pill = e.target.closest(".pill-filter,[data-pill-tag]");
      if (pill) {
        // ignore clicks on synthetic "active-group/value" chips (handled above)
        if (pill.classList.contains("active-group-pill") || pill.classList.contains("active-value-pill")) {
          return;
        }
        stop(e);

        // BADGES ARE MULTI-SELECT; no mutual exclusion
        const nowActive = !pill.classList.contains("is-active");
        pill.classList.toggle("is-active", nowActive);
        pill.setAttribute("aria-pressed", String(nowActive));
        refreshBadgePillIcons();

        // Maintain ?badge=a,b,c with original badge keys (not aliases)
        const allBadges = Array.from(document.querySelectorAll('.pill-filter[data-filter-group="badge"].is-active'))
          .map(btn => toHandleLoose(btn.getAttribute('data-filter-value')))
          .filter(Boolean);
        const u = new URL(location.href);
        setBadgesInURL(u, allBadges);
        // Reset to page 1 after toggling filters to avoid empty pages
        u.searchParams.delete('page');
        history.replaceState({}, "", u.pathname + u.search);

        window.applyFilters?.();
        return;
      }

      if (IS_LOCALHOST) {
        const a = e.target.closest("a[href]");
        if (a) {
          const href = a.getAttribute("href") || "";
          if (/\/collections\/[^\/?#]+\/products\/[^\/?#]+/.test(href)) {
            stop(e);
            const url = new URL(href, location.origin);
            const m = url.pathname.match(/\/products\/[^\/?#]+/);
            if (m) {
              const newPath = m[0] + (url.search || "") + (url.hash || "");
              location.assign(newPath);
              return;
            }
          }
        }
      }
    }, true);

    document.addEventListener("change", (e) => {
      const panelCb = e.target.closest(".filter-group-panel__checkbox");
      if (panelCb) {
        const gName = panelCb.getAttribute("data-panel-group");
        const vName = panelCb.getAttribute("data-panel-value");

        $all("[data-tag-filter-checkbox][data-filter-group]").forEach((cb) => {
          const g = (cb.getAttribute("data-filter-group") || "").trim();
          const v = (cb.getAttribute("data-filter-value") || cb.value || "").trim();
          if (toHandleLoose(g) === toHandleLoose(gName) && toHandleLoose(v) === toHandleLoose(vName)) cb.checked = panelCb.checked;
        });

        $all(".pill-filter,[data-pill-tag]").forEach((btn) => {
          const g2 = (btn.getAttribute("data-filter-group") || "").trim();
          const v2 = (btn.getAttribute("data-filter-value") || btn.getAttribute("data-pill-tag") || "").trim();
          if (toHandleLoose(g2) === toHandleLoose(gName) && toHandleLoose(v2) === toHandleLoose(vName)) {
            if (panelCb.checked) { btn.classList.add("is-active"); btn.setAttribute("aria-pressed", "true"); }
            else { btn.classList.remove("is-active"); btn.setAttribute("aria-pressed", "false"); }
          }
        });

        // Reset to 1 on panel selection change
        try {
          const u = new URL(location.href);
          u.searchParams.delete('page');
          history.replaceState({}, '', u.pathname + u.search);
        } catch {}

        window.applyFilters?.();
        renderActivePills();
        return;
      }

      // change on tag checkbox → reset page=1, keep sort/badge
      const cb = e.target.closest("[data-tag-filter-checkbox]");
      if (cb) {
        stop(e);
        const u = new URL(location.href);
        u.searchParams.delete('page');
        history.replaceState({}, '', u.pathname + u.search);
        window.applyFilters?.();
        return;
      }

      const select = e.target.closest('.collection__sort-by-filter select, select[name="sort_by"]');
      if (select) { stop(e); applySort(select.value); return; }
    }, true);

    document.addEventListener("submit", (e) => {
      if (!e.target.closest(".sidebar__block")) return;
      stop(e);
      try {
        const u = new URL(location.href);
        u.searchParams.delete('page'); // reset to 1 on submit as well
        history.replaceState({}, '', u.pathname + u.search);
      } catch {}
      window.applyFilters?.();
    }, true);
  })();

  /* =========================
     Init / reinit
  ========================== */
 function reinitCollectionUI(root) {
  harvestOriginalLabels(root || document);
  normalizeAccordions(root || document);
  renderActivePills();
}


  window.reinitCollectionUI = reinitCollectionUI;
  window.reinitFlexGrid = reinitFlexGrid;

  function coercePathBadgeToQuery() {
    const pathHandles = urlHandlesFromPath(); // e.g. ["tee-neuheiten"]
    if (!pathHandles.length) return;

    // Find if any path handle is one of your badge aliases
    const hitKey = Object.keys(BADGE_ALIASES).find(key =>
      pathHandles.some(h => (h === key) || BADGE_ALIASES[key].includes(h))
    );
    if (!hitKey) return;

    // Visually activate that badge pill
    const btn = document.querySelector(
      `.pill-filter[data-filter-group="badge"][data-filter-value="${hitKey}"]`
    );
    if (btn && !btn.classList.contains('is-active')) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed','true');
    }

    // Rewrite URL to base + ?badge=<key> (carry sort & page)
    const base = buildSeoURLFromHandles([], {}); // /collections/<handle>
    const u = new URL(base.pretty.href);
    u.searchParams.set('badge', hitKey);
    const cur = new URL(location.href);
    const sort = cur.searchParams.get('sort_by');
    if (sort) u.searchParams.set('sort_by', sort);
    const page = cur.searchParams.get('page');
    if (page) u.searchParams.set('page', page);

    history.replaceState({}, '', u.pathname + u.search);
  }

  async function init() {
    document.documentElement.setAttribute('data-coll-pending','1');

    cacheIconsFromDOM();
    ensureGroupPanel();
    hideBlockedOptionsInDOM();
    harvestOriginalLabels(document);
    coercePathBadgeToQuery();

    // Reflect ?badge in pill visual state
    const badges = getBadgesFromURL();
    if (badges.length) {
      badges.forEach(b=>{
        const btn = document.querySelector('.pill-filter[data-filter-group="badge"][data-filter-value="'+b+'"]');
        if (btn && !btn.classList.contains('is-active')) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed','true');
        }
      });
    }

    await ensurePerPage();
    cachePagerFrom(document);

    const path = urlHandlesFromPath();
    if (path.length) setActiveValues(path);

    // capture the initial selection so we don't reset page on first hydrate
    __LAST_SELECTION_KEY__ = makeSelectionKey(readGroupsFromDOM());

    reinitCollectionUI();
    reinitFlexGrid();

    // hydrate current state (keeps page/sort/badge intact due to branch above)
    if (typeof window.applyFilters === 'function') window.applyFilters();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", (e) => { reinitCollectionUI(e.target); });
  document.addEventListener("shopify:section:select", (e) => { reinitCollectionUI(e.target); });

  /* expose accordion helper early (fixes ReferenceError) */
  window.toggleAccordionFrom = toggleAccordionFrom;

})();